import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "transparent",
    boxShadow: "none",
    position: "relative",
    paddingRight: 5,
    paddingTop: 15,
    "@media(max-width:767px)": {
      paddingRight: 0,
    },
  },
  tool: {
    paddingLeft: 12,
    paddingRight: 12,
  },
}));
export default useStyles;
